import { useTranslation } from "react-i18next";

function CouponsStatusPreview() {
  const { t } = useTranslation();

  const statuses = [
    { label: "active", color: "bg-green-500" },
    { label: "not active", color: "bg-gray-500" },
    { label: "expire", color: "bg-yellow-500" }
  ];

  return (
    <div className="flex items-center gap-4 text-sm font-semibold capitalize">
      {statuses.map((status, index) => {
        const translationKey = status.label === "active" ? "active" :status.label === "expire" ? "expired" : "inactive";
        return (
          <div key={index} className="flex items-center gap-2">
            <span className={`mt-1 h-2 w-4 rounded-full ${status.color}`}></span>
            {t(`couponStatus.status.${translationKey}`)}
          </div>
        );
      })}
    </div>
  );
}

export default CouponsStatusPreview;
